// eslint-disable-next-line no-restricted-imports
import { DirectCampaignUI } from '../../../data-layer/direct/types';

/** Цели метрики оптимизации конверсий (id и стоимость конверсии) */
export interface DirectGoal {
    /** Идентификатор цели */
    goal_id: number;
    /** Название цели */
    name: string;
    /** Стоимость конверсии в рублях */
    cost: number;
}

/** Счетчик метрики */
export interface DirectCounter {
    /** Идентификатор счетчика */
    counter_id: number;
    /** Домен */
    domain: string;
    /** Цели */
    goals: DirectGoal[];
}

/** Регион */
export interface DirectRegion {
    /** Идентификатор региона */
    region_id: number;
    /** Название региона */
    name: string;
}

/** Ссылки кампании */
export interface DirectCampaignLinks {
    /** Ссылка на статистику */
    mol: string;
}

export type DirectCampaignStatus = 'DRAFT' | 'ACCEPTED' | 'MODERATION' | 'REJECTED' | 'UNKNOWN';

export enum DirectProcessText {
    START = 'Запустить',
    SUSPEND = 'Остановить',
    RESUME = 'Возобновить',
}

export type DirectCampaignState =
    | 'ON'
    | 'OFF'
    | 'ARCHIVED'
    | 'CONVERTED'
    | 'ENDED'
    | 'SUSPENDED'
    | 'UNKNOWN';

export interface ContentPromotionProps {
    directCompanies?: DirectCampaignUI[];
    isLoading?: boolean;
    isAuthorized?: boolean;
}
